export default __webpack_public_path__ + "static/media/m-fsk-16.68b0b0cf.jpg";